module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av516-b6e21d2cab8342d3ca027bb3a398b2cd.jpg";